/**
 * SVG tilt selector 
 */
define('commons/tilt-selector',['jquery', 'd3js', 'utils/trigo'], function($, d3, trigo) {
    var Tilt = function(container, options) {
        this.options= {
            'width' : 300,
            'height' : 300,
            'radius' : 200,
            'lineWidth' : 10,
            'onChangeTilt' : undefined
        };
        // Extends options
        $.extend(this.options, options);
        this.container = container;
        $(this.container).css( "width", this.options.width );
        $(this.container).css( "height", this.options.height );
        $(this.container).css( "float", "left" );
        this.lineTiltId = "lineTilt";
        this.xOrigin = 40;
        this.yOrigin = this.options.height / 2;
        this.xEast = this.xOrigin + this.options.radius;
        this.yEast = this.yOrigin;
        this.draw();
    };
    
    Tilt.prototype.draw = function() {
        var self = this;
        // Init SVG
        this.svg = d3.select(this.container)
                        .insert("svg")
                        .attr("width", this.options.width)
                        .attr("height", this.options.height);
        // Init Arc
        this.arc = d3.svg.arc().innerRadius(1).outerRadius(this.options.radius).startAngle(trigo.toRadians(-10)+Math.PI/2).endAngle(Math.PI);
        // Draw arc
        this.zone = this.svg.append("path")
                        .attr("d", this.arc)
                        .attr("transform", "translate("+this.xOrigin+","+this.yOrigin+")")
                        .attr('stroke-width', 2)
                        .attr('stroke', 'gray')
                        .attr('fill', 'white');
        // define line marker (start line - circle - and end line - arrow -)
        this.svg.append('svg:defs').append('svg:marker')
            .attr('id', 'el-start-line')
            .attr('viewBox', '0 0 10 10')
            .attr('refX', 5)
            .attr('refY', 5)
            .attr('markerWidth', 3)
            .attr('markerHeight', 3)
            .attr('orient', 'auto')
            .attr('fill', 'grey')
          .append('circle')
            .attr('r', '5')
            .attr('cx', '5')
            .attr('cy', '5');
        this.svg.append('svg:defs').append('svg:marker')
            .attr('id', 'el-arrow')
            .attr('viewBox', '0 -5 10 10')
            .attr('refX', 0)
            .attr('markerWidth', 1)
            .attr('markerHeight', 1)
            .attr('orient', 'auto')
            .attr('fill', 'grey')
            .append('svg:path').attr('d', 'M0,-5L10,0L0,5');
        // Create ticks
        var decX = 10;
        var decY = 5;
        this.svg.append("svg:text").text( "-10°" ).attr("transform", function(data, index) { return "translate(" + (self.options.radius*Math.cos(trigo.toRadians (-10)) + self.xOrigin + 10) + "," + (self.options.radius*Math.sin(trigo.toRadians (-10)) + self.yOrigin) + ")" + "rotate(" + -10 + ")"; }).style("font-size", "12px");
        this.svg.append("svg:text").text( "0°" ).attr("transform", function(data, index) { return "translate(" + (self.options.radius*Math.cos(0) + self.xOrigin + 15) + "," + (self.options.radius*Math.sin(0) + self.yOrigin + 5) + ")" + "rotate(" + 0 + ")"; }).style("font-size", "12px");
        this.svg.append("svg:text").text( "45°" ).attr("transform", function(data, index) { return "translate(" + (self.options.radius*Math.cos(Math.PI/4) + self.xOrigin + 10) + "," + (self.options.radius*Math.sin(Math.PI/4) + self.yOrigin + 15) + ")" + "rotate(" + 45 + ")"; }).style("font-size", "12px");
        this.svg.append("svg:text").text( "90°" ).attr("transform", function(data, index) { return "translate(" + (self.options.radius*Math.cos(Math.PI/2) + self.xOrigin -5) + "," + (self.options.radius*Math.sin(Math.PI/2) + self.yOrigin + 15) + ")" + "rotate(" + 90 + ")"; }).style("font-size", "12px");
        for (var i = -10; i <= 90; i += 5){
            var bigTick = i%15 === 0;
            var size = (bigTick?10:5);
            this.svg.append('line')
                        .attr('x1', Math.cos(trigo.toRadians (i)) * this.options.radius + this.xOrigin)
                        .attr('y1', Math.sin(trigo.toRadians (i)) * this.options.radius + this.yOrigin)
                        .attr('x2', Math.cos(trigo.toRadians (i)) * (this.options.radius + size) + this.xOrigin)
                        .attr('y2', Math.sin(trigo.toRadians (i)) * (this.options.radius + size) + this.yOrigin)
                        .style('stroke', 'grey')
                        .style('stroke-width', '1px');
        }
        // Create drag action
        this.drag = d3.behavior.drag().on("drag", $.proxy(function(d) {
            var mouse = d3.mouse(this);
            var xMouse = mouse[0];
            var yMouse = mouse[1];
            var angle = trigo.getAngle(xMouse, yMouse, self.xEast, self.yEast, self.xOrigin, self.yOrigin);
            self.moveToAngle(angle, d3.select(this));
        }), this);
        // Create elevation selector
        this.line_elevation = this.createLine(0, this.lineTiltId, true, true);
    };
    
    Tilt.prototype.createLine = function(angle, id, start, end){
        var line = this.svg.append("line")
                            .attr("id", id)
                            .attr("x1", this.xOrigin)
                            .attr("y1", this.yOrigin)
                            .attr("x2", Math.cos(angle) * this.options.radius + this.xOrigin)
                            .attr("y2", Math.sin(angle) * this.options.radius + this.yOrigin)
                            .attr('stroke-width', this.options.lineWidth)
                            .attr('stroke', 'gray')
                            .call(this.drag);
        if (start){
            line.attr('marker-start', 'url(#el-start-line)');
        }
        if (end){
            line.attr('marker-end', 'url(#el-arrow)');
        }
        return line;
    };
    
    Tilt.prototype.moveToAngle = function(angle, line){
        var radMin = trigo.toRadians(350);
        if (angle >= Math.PI && angle <= radMin){
            angle = radMin;
        } else if (angle > (Math.PI / 2) && (angle < Math.PI)){
            angle = Math.PI / 2;
        }
        // Set the new position
        line.attr("x2", Math.cos(angle) * this.options.radius + this.xOrigin).attr("y2", Math.sin(angle) * this.options.radius + this.yOrigin);
        if (this.options.onChangeTilt){
            // get degrees and rotate
            var degrees = trigo.toDegrees(angle);
            if (degrees > 90){
                degrees = degrees - 360;
            }
            this.options.onChangeTilt.call(this, degrees.toFixed(2));
        }
    };
    
    Tilt.prototype.setTilt = function(degrees){
        this.moveToAngle(trigo.toRadians(degrees), this.line_elevation);
    };
    
    return Tilt;
});

